<template>
<div class="progress-group">
   <h6 class="title">
      {{ title }}
      <button class="action" type="button" @click="$emit('click')" v-if="showActionButton">Change</button>
   </h6>
   <slot></slot>
</div>
</template>

<script>
export default {
  name: 'ProgressGroup',
  props: {
    title: String,
    showActionButton: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.progress-group {
   > .title {
      position: relative;
      text-transform: uppercase;
      font-size: 13px;
      font-weight: 700;
      color: #232323;
      margin: 24px 0 0 0;
      padding: 0 65px 0 0;
   }
   .action {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      font-size: 13px;
      font-weight: 700;
      border: none;
      color: $brand-colour-primary;
      background-color: transparent;

      &:hover {
        text-decoration: underline;
      }
   }
}
</style>
